import { rolesById } from '../constants/roles';

const getNecessaryRoles = (necessaryRoles, userRoleIds) => userRoleIds.filter((userRoleId) => {
  const userRole = rolesById[userRoleId];
  const hasNecessaryRole = necessaryRoles.includes(userRole);
  return hasNecessaryRole;
});

export default getNecessaryRoles;
